const NoData = () => {
  return (
    <div style={{ flex: 1, textAlign: "center", fontSize: 30 }}>
      Não existem dados a serem exibidos.
    </div>
  );
};

export default NoData;
